<template>
  <div class="have-account">
    <p>
      {{ haveAccountData.haveAccountTitle }}
      <span>
        <router-link v-bind:to="haveAccountData.haveAccountLink">
          {{ haveAccountData.haveAccountButtonText }}
        </router-link>
      </span>
    </p>
  </div>
</template>

<script>
export default {
  name: 'HaveAccount',
  props: ['haveAccountData'],
};
</script>

<style scoped>
  .have-account {
    color: #c4c4c4;
    position: absolute;
    top: 2.625rem;
    right: 2.75rem;
    font-size: 1rem;
  }
  .have-account span {
    color: #070581;
    font-weight: bold;
  }
  @media only screen and (max-width: 767px) {
    .have-account {
      right: 0;
      padding: 1.875rem;
      top: 0;
    }
  }
</style>
